<template>
  <b-card>
    <b-row class="mb-2">
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('sms.manager')">
          <v-select
            v-model="filter.manager"
            :options="onFilter"
            label="first_name"
            :reduce="(user) => user.id"
            class="bg-white"
            @input="reFilter"
          >
            <li slot="list-footer" class="pagination">
              <button
                :disabled="!getUsers.previous"
                @click="previousUsersGet()"
              >
                {{ $t("prev") }}
              </button>
              <button
                :disabled="!getUsers.next"
                @click="nextUsersGet()"
              >
                {{ $t("next") }}
              </button>
            </li>
          </v-select>
        </b-form-group>
      </b-col>
      <b-col class="col-lg-2 col-md-3 col-12">
        <b-form-group :label="$t('general.report_date')">
          <VueDataPicker :other-props="{ 'is-range': true }" v-model="report" />
        </b-form-group>
      </b-col>
    </b-row>
    <div style="overflow-x: auto">
      <table class="table">
        <thead class="center-th">
          <tr>
            <th rowspan="2">{{ $t("general.object_name") }}</th>
            <th colspan="6">{{ $t("general.sold_flats") }}</th>
          </tr>
          <tr>
            <th scope="col">{{ $t("general.numbers_room") }}</th>
            <th scope="col">м2</th>
            <th scope="col">{{ $t("general.price") }}</th>
            <th scope="col">{{ $t("general.price_clients") }}</th>
            <th scope="col">{{ $t("general.luxury_ras") }}</th>
            <th scope="col">{{ $t("general.total_borrow") }}</th>
          </tr>
        </thead>
        <tbody class="center-td">
          <tr v-for="item in GET_SOLD_FLAT" :key="item.id">
            <td>{{ item.title }}</td>
            <td>{{ item.total_sold_flat_count }}</td>
            <td>{{ item.total_sold_flat_area }}</td>
            <td>{{ $_moneyFormatter(item.total_sold_flat_amount) }}</td>
            <td>{{ $_moneyFormatter(item.total_customer_paid_amount) }}</td>
            <td>{{ $_moneyFormatter(item.total_month_debt) }}</td>
            <td>{{ $_moneyFormatter(item.total_debt) }}</td>
          </tr>
          <tr style="background-color: #f3f2f7">
            <td>
              {{ $t('general.last') }}
            </td>
            <td>{{ totalSoldFlatCount }}</td>
            <td>{{ totalSoldFlatArea }}</td>
            <td>{{ $_moneyFormatter(totalSoldFlatAmount) }}</td>
            <td>{{ $_moneyFormatter(totalCustomerPaidAmount) }}</td>
            <td>{{ $_moneyFormatter(totalMonthDebt) }}</td>
            <td>{{ $_moneyFormatter(totalDebt) }}</td>
          </tr>
        </tbody>
      </table>
    </div>
  </b-card>
</template>

<script>
import { mapGetters, mapActions } from "vuex";
import {
  BCard,
  BSpinner,
  BTr,
  BTh,
  BTable,
  BRow,
  BFormGroup,
  BCol,
} from "bootstrap-vue";
import formatters from "@/mixins/extra";
import VueDataPicker from "@/components/VueDatePicker.vue";
import VSelect from "vue-select";
export default {
  components: {
    BRow,
    BFormGroup,
    BCol,
    BCard,
    VSelect,
    VueDataPicker,
    BTable,
    BSpinner,
    BTr,
    BTh,
  },
  mixins: [formatters],

  data() {
    return {
      loader: false,
      report: null,
      params: {
        page: 1,
      },

      filter: {
        manager: null,
        from_date: null,
        to_date: null,
      },
      fields: [
        {
          key: "id",
          label: "ID",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "title",
          label: "Obyekt nomi",
        },
        {
          key: "total_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_count",
          label: "Soni",
          thClass: "text-center",
          tdClass: "text-center",
        },
        {
          key: "total_sold_flat_area",
          label: "m2",
          thClass: "text-center",
          tdClass: "text-center",
        },
      ],
    };
  },

  computed: {
    ...mapGetters("objects", ["GET_REPORTS_TABLE", "GET_SOLD_FLAT"]),
    ...mapGetters("clients", ["getUsers"]),
    onFilter() {
      return [{ first_name: "все", id: "all" }].concat(this.getUsers.results);
    },
    totalDebt() {
      let data = this.GET_SOLD_FLAT.map((item) => {
        return item.total_debt;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalMonthDebt() {
      let data = this.GET_SOLD_FLAT.map((item) => {
        return item.total_month_debt;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalCustomerPaidAmount() {
      let data = this.GET_SOLD_FLAT.map((item) => {
        return item.total_customer_paid_amount;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalSoldFlatAmount() {
      let data = this.GET_SOLD_FLAT.map((item) => {
        return item.total_sold_flat_amount;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalSoldFlatArea() {
      let data = this.GET_SOLD_FLAT.map((item) => {
        return item.total_sold_flat_area;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
    totalSoldFlatCount() {
      let data = this.GET_SOLD_FLAT.map((item) => {
        return item.total_sold_flat_count;
      });
      return data.reduce((oldValue, newValue) => {
        return oldValue + newValue;
      }, 0);
    },
  },
  watch: {
    report(val) {
      this.filter.from_date = val?.start;
      this.filter.to_date = val?.end;
      this.FETCH_SOLD_FLAT(this.filter);
    },
  },
  mounted() {
    this.FETCH_SOLD_FLAT();
    this.FETCH_USERS_LIST({...this.params, role: 6});
    // this.FETCH_REPORTS_TABLE().then(() => {
    //   this.loader = false;
    // });
  },

  methods: {
    ...mapActions("objects", ["FETCH_REPORTS_TABLE", "FETCH_SOLD_FLAT"]),
    ...mapActions("clients", ["FETCH_USERS_LIST"]),
    reFilter(val) {
      if (val == "all") {
        this.FETCH_SOLD_FLAT();
      } else {
        this.FETCH_SOLD_FLAT(this.filter);
      }
    },



    async previousUsersGet() {
      if (this.getUsers.previous) {
        // const page = this.getUsers.previous;
        this.params.page--;

        await this.FETCH_USERS_LIST({...this.params, role: 6});
      }
    },



    async nextUsersGet() {
      if (this.getUsers.next) {
        // const page = this.getUsers.next;
        this.params.page++;

        await this.FETCH_USERS_LIST({...this.params, role: 6});
      }
    },




  },
};
</script>

<style>
table,
th,
th {
  border: 1px solid #ccc !important;
}
.bg-warning {
  background: #fefe00 !important;
}

table {
  border: 0px solid red !important;
}

td {
  white-space: nowrap;
}

.text-center {
  text-align: center !important;
}

.center-th th {
  vertical-align: middle !important;
  text-align: center !important;
}
.center-td td {
  vertical-align: middle !important;
  text-align: center !important;
}


.dark-layout .pagination  button{
  color: #fff !important;
  background-color: #3b4253 !important;
}

.pagination {
  display: flex;
  margin: 0.25rem 0.25rem 0;
}
.pagination button {
  flex-grow: 1;
  border: 1px solid #ccc;
}
.pagination button:hover {
  cursor: pointer;
}
</style>
